export default "__VITE_ASSET__CxMKkqHp__"